export default "__VITE_ASSET__D$2dFEBf__"